export enum EAssociateFailedReason {
    /** 绑定出错 */
    BIND_ERROR = 'bind_error',
    /** 其他失败原因（兜底） */
    OTHER = 'other',
}

export interface IAssociateFailedDevice {
    /**
     * 失败的设备 uid
     */
    uid: string;

    /**
     * 失败原因
     */
    reason: EAssociateFailedReason;
}

export interface IDeviceAssociation {
    /**
     * 当前设备关联的订阅 id
     * 取值范围: safe_uint 字符串
     */
    subscription: string;

    /**
     * 设备 uid
     * 取值范围： 16 个字符
     */
    uid: string;

    /**
     * 存储时长
     * 取值范围：int(0,365)
     */
    retentionDays?: number;
}

export interface IBatchDeviceAssociationResponse {
    /**
     * 操作成功的 uid
     */
    successUids: string[];

    /**
     * 操作失败的设备和原因
     */
    failedDevices: IAssociateFailedDevice[];
}

export interface IBatchAssociateDeviceArgs {
    /**
     * 要关联的订阅和设备关系列表
     * 长度 1-100
     */
    associateDevices: IDeviceAssociation[];
}

export interface IBatchUnassociateDevicesArgs {
    /**
     * 要解关联的订阅和设备信息
     * 长度大于等于 1，小于等于 100
     */
    unassociateDevices: IDeviceAssociation[];
}

export interface IChangeAssociateDevicesArgs {
    associateDevices?: IDeviceAssociation[];
    unassociateDevices?: IDeviceAssociation[];
}

export interface IDeviceAssociationResultItem {
    status: 'success' | 'failed';
    type: 'associate' | 'unassociate';
    reason?: EAssociateFailedReason;
}

export interface IChangeAssociateDevicesResponse {
    deviceResults: Record<string, IDeviceAssociationResultItem>;
}
